<script context='module'>
  import { getContext } from 'svelte';

  const MOTION = Symbol('Motion');

  export const Motion = {
    REGULAR: Symbol('Motion.Regular'),
    REDUCED: Symbol('Motion.Reduced'),
    NONE: Symbol('Motion.None'),
  };

  export const useMotion = () => getContext(MOTION);
</script>

<script>
  import Provider from '../Provider';
  import { browser } from '$app/environment';

  export let level = undefined;

  if (browser) {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mediaQuery?.matches) {
      level ??= Motion.REDUCED;
    }
  }
</script>

<Provider key={MOTION} value={level}>
  <slot />
</Provider>
